import { addDisplayedEnum } from './enumCommon.js';

const EmploymentSetupStatus = addDisplayedEnum(
  {
    REQUESTED_BY_EMPLOYER: 'requestedByEmployer', //employer requests - at this point the Employment fields are editable, including activation code
    INITIATED_BY_EMPLOYEE: 'initiatedByEmployee', //employee initiates - Employment fields no longer editable, User has taken over
    NAME_REVIEW_REQUIRED: 'nameReviewRequired', // employee has completed onboarding, but the name doesn't match
    PAYROLL_UPDATE_REQUIRED: 'payrollUpdateRequired', //employee has made an election or an update, and the administrator needs to update the system for it
    PENDING_ADMIN_PROCESSING: 'pendingAdminProcessing', //generic state for the above two which will be shown to users
    ACTIVE_EMPLOYMENT: 'activeEmployment', //backend process completed, account/routing numbers available - at this point the Employment data is no longer shown, instead the corresponding User data
  },
  'EmploymentSetupStatus',
);

const PayrollElectionType = addDisplayedEnum(
  {
    CONTRIBUTION_PERCENT: 'contributionPercent',
    CONTRIBUTION_DOLLARS: 'contributionDollars',
  },
  'PayrollElectionType',
);

export { EmploymentSetupStatus, PayrollElectionType };
